import React from "react";
import { useTranslation } from "react-i18next";
import { renderHTML } from "../hooks/htmlToText";

export const PrivacyPolicyIntro = () => {
  const { t } = useTranslation();

  return (
    <div className="gap-5 flex flex-col">
      <h1 className=" text-[26px] md:text-[28px] font-600 uppercase">
        {String(t("policyPage.title"))}
      </h1>
      <div className="flex flex-col gap-5">
        <p className="font-600  text-[16px] md:text-[18px]">
          {String(t("policyPage.date"))}
        </p>
        <div className="text-14px md:text-[16px] leading-[25px] md:leading-[30px]">
          {renderHTML(String(t("policyPage.p1")))}
          <ul className="list-disc ml-[30px]">
            <li>{renderHTML(String(t("policyPage.ul1")))}</li>
            <li>{renderHTML(String(t("policyPage.ul2")))}</li>
            <li>{renderHTML(String(t("policyPage.ul3")))}</li>
          </ul>
        </div>
        <div className="text-14px md:text-[16px] leading-[25px] md:leading-[30px] flex flex-col gap-5">
          <p className="font-600  text-[16px] md:text-[18px]">
            {renderHTML(String(t("policyPage.q1")))}
          </p>
          <div>
            <p>{renderHTML(String(t("policyPage.a1")))}</p>
            <p>{renderHTML(String(t("policyPage.a2")))}</p>
            <p>{renderHTML(String(t("policyPage.a3")))}</p>
            <p>{renderHTML(String(t("policyPage.a4")))}</p>
          </div>
        </div>
      </div>
    </div>
  );
};
